import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import Toolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Input from "@material-ui/core/Input";
import MaskedInput from "react-text-mask";
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import { DropzoneArea } from "material-ui-dropzone";
import DateTimePicker from "react-datetime";
import SelectFilter from "react-select";
import FileAttachControl from "./controls/FileAttachControl";
import ConfirmDialog from "./ConfirmDialog";

import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import moment from "moment";

import MyButton from "./MyButton";

const myLib = require("../lib/MyLib");
const server = require("../lib/server");
const sukienLayer = require("../lib/TrucBanLayer");

class TrucBanDenEditDialog extends React.Component {
  constructor(props) {
    super(props);
    this.saveField = this.saveField.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.state = {
      open: props.visible,
      fullWidth: true,
      maxWidth: "sm",
      canSaved: false, //cho phep save hay khong
      dataChanged: false, //du lieu co su thay doi hay khong
      saving: false, //co dang save du lieu hay khong
      errorLog: "", //mo ta loi neu co
      loading_doitac: true, // co dang load ding danh muc nguon tin ko
      source_doitac: [], //danh muc options cho nguon tin
      loading_sukien: true,
      source_sukien: [],
      before:
        props.value === undefined
          ? {
              ThoiGian: new Date(),
            }
          : myLib.cloneObject(props.value), //thong tin truoc khi edit
      after:
        props.value === undefined
          ? {
              TrucBanID: 0,
              ThoiGian: new Date(),
              PhuongThuc: "1",
              NoiDung: "",
              MaDoiTac: null,
              TenNoiNhan: "",
              LoaiThongTin: "0",
              MaSK: null,
            }
          : props.value, //thong tin dang edit
      mountUploader: false,
      files: [], //file dinh kem chua saved
      fileDinhKem: [], //danh sach file dinh kem da saved
      validateStatus: { error: false }, //trang thai validate
    };
  }

  //ghi nhan gia tri nhap
  saveField = (fieldName, value) => {
    if (fieldName === "files") {
      var s = this.state;
      s.files = value;
      this.setState(s);
    } else {
      var s = this.state;
      s.after[fieldName] = value;
      s.dataChanged = !myLib.isSame(s.before, s.after, [
        "ThoiGian",
        "PhuongThuc",
        "NoiDung",
        "MaDoiTac",
        "TenNoiNhan",
        "LoaiThongTin",
        "MaSK",
      ]);
      s.canSaved = s.dataChanged;
      console.log("before", s.before, "after", s.after);
      this.setState(s);
    }
  };
  //submit thong tin ve DB
  handleSave = () => {
    if (this.props.EditMode !== "xoa") {
      var check = sukienLayer.validate("den", this.state.after);
      if (!check.error) {
        //console.log(JSON.stringify(this.state.after));
        this.setState({ validateStatus: check, saving: true, errorLog: "" });
        server
          .post(
            "trucban/saveDen",
            sukienLayer.chuanHoa("abc", this.state.after)
          )
          .then((response) => {
            var before = {};
            var after = { ...this.state.after, TrucBanID: response.TrucBanID };
            Object.assign(before, after);
            this.setState({
              before: before,
              after: after,
              dataChanged: false,
              canSaved: false,
              saving: false,
              errorLog: "",
            });
            //thong bao cho parent biet co data duoc saved
            if (this.props.onSaved) {
              this.props.onSaved(after);
            }
          })
          .catch((error) =>
            this.setState({ saving: false, errorLog: error + "" })
          );
      } else {
        this.setState({ validateStatus: check });
      }
    } else {
      this.setState({ saving: true, errorLog: "" });
      server
        .post("trucban/xoa", this.state.after)
        .then((response) => {
          var before = {};
          this.setState({
            dataChanged: false,
            canSaved: false,
            saving: false,
            errorLog: "",
          });
          this.handleClose();
        })
        .catch((error) =>
          this.setState({ saving: false, errorLog: error + "" })
        );
    }
  };
  componentDidMount() {
    this.loadDanhMuc();
    this.loadEdit();
  }
  loadDanhMuc() {
    //load danh muc doi tac
    server
      .query("doitac/getall")
      .then((response) => {
        var list = [];
        response.map((item, index) =>
          list.push({ value: item.MaDoiTac, label: item.TenDoiTac })
        );
        this.setState({ source_doitac: list, loading_doitac: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_doitac: false, errorLog: error + "" });
      });
    //load danh muc su kien co lien quan
    server
      .query(
        "sukien/getlienquan?trucbanid=" +
          (this.props.TrucBanID === undefined ? 0 : this.props.TrucBanID)
      )
      .then((response) => {
        var list = [];
        response.map((item, index) =>
          list.push({ value: item.MaSK, label: item.TenSK })
        );
        this.setState({ source_sukien: list, loading_sukien: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading_sukien: false, errorLog: error + "" });
      });
  }
  loadEdit() {
    //kiem tra xem co phai che do edit hay khong
    var mask = this.props.TrucBanID;
    if (mask !== undefined) {
      //load va hien thi thong tin su kien
      server
        .query("trucban/get?TrucBanID=" + mask)
        .then((response) => {
          //thong tin su kien
          var sukien = response.trucban;
          sukien = sukienLayer.chuyenDoi(sukien); //chuyen doi gia tri
          console.log(sukien, "chuyen doi");
          this.setState({
            formReady: true,
            before: sukien,
            after: myLib.cloneObject(sukien),
            fileDinhKem: response.dinhkem,
          });
          console.log("ket qua truy van", sukien);
        })
        .catch((error) => {
          console.log(error);
          this.setState({ loading_coquan: false, errorLog: error + "" });
        });
    } else {
      this.setState({ formReady: true });
    }
  }
  handleClose = () => {
    this.setState({ open: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  };
  static getDerivedStateFromProps(props, state) {
    return { ...state };
  }
  render() {
    const { classes, theme } = this.props;
    return (
      <React.Fragment>
        <Dialog
          fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="max-width-dialog-title"
          disableBackdropClick
        >
          <DialogTitle id="max-width-dialog-title">
            <AppBar position="static">
              <Toolbar>
                <IconButton
                  edge="start"
                  className={classes.menuButton}
                  color="inherit"
                  aria-label="menu"
                >
                  <MenuIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                  Thông tin đến
                </Typography>
                {this.props.EditMode === "xoa" ? (
                  <Button color="inherit" onClick={this.handleSave}>
                    Xóa
                  </Button>
                ) : null}
                <Button color="inherit" onClick={this.handleClose}>
                  Thoát
                </Button>
              </Toolbar>
            </AppBar>
          </DialogTitle>
          <DialogContent>
            <form className={classes.form} noValidate autoComplete="off">
              <div style={{ height: 600 }}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <InputLabel id="labelCoquan" className={this.state.validateStatus.MaDoiTac !== undefined
                          ? classes.labelError
                          : classes.label}>
                      Nơi nhận(*):
                    </InputLabel>
                    {this.state.loading_doitac ? (
                      <CircularProgress />
                    ) : (
                      <div style={{ zIndex: 99999 }}>
                        <SelectFilter
                          id="cboMaDoiTac"
                          options={this.state.source_doitac}
                          placeholder=""
                          autoFocus={true}
                          labelId="labelCoquan"
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          menuPosition={"fixed"}
                          value={this.state.after.MaDoiTac}
                          onChange={(item) => this.saveField("MaDoiTac", item)}
                        ></SelectFilter>
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id="txtTenNoiNhan"
                      className={classes.textbox}
                      multiline
                      label="Tên khác:"
                      value={this.state.after.TenNoiNhan}
                      InputProps={{
                        maxLength: 500,
                        width: 500,
                      }}
                      onChange={(event) =>
                        this.saveField("TenNoiNhan", event.target.value)
                      }
                      error={this.state.validateStatus.TenNoiNhan !== undefined}
                      helperText={
                        this.state.validateStatus.TenNoiNhan !== undefined
                          ? this.state.validateStatus.TenNoiNhan.trangthai
                          : undefined
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <InputLabel
                      id="labelTungay"
                      className={
                        this.state.validateStatus.ThoiGian !== undefined
                          ? classes.labelError
                          : classes.label
                      }
                    >
                      Thời gian(*):
                    </InputLabel>
                    <DateTimePicker
                      id="txtThoigian"
                      dateFormat="DD/MM/YYYY"
                      timeFormat="HH:mm"
                      closeOnSelect={true}
                      value={this.state.after.ThoiGian}
                      InputProps={{
                        maxLength: 100,
                        onBlur: (event) => {
                          var text = event.target.value;
                          if (
                            this.state.after.ThoiGian === null &&
                            text != ""
                          ) {
                            var date = myLib.tryToDate(text);
                            if (date) {
                              this.saveField("ThoiGian", date);
                            }
                          }
                        },
                      }}
                      onChange={(date) =>
                        this.saveField(
                          "ThoiGian",
                          date && date.toDate ? date.toDate() : null
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl className={classes.formControl}>
                      <InputLabel
                        id="demo-simple-select-label"
                        className={classes.label}
                      >
                        Phương thức(*):
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className={classes.combo}
                        autoWidth={true}
                        labelWidth={100}
                        value={this.state.after.PhuongThuc}
                        onChange={(event) =>
                          this.saveField("PhuongThuc", event.target.value)
                        }
                      >
                        <MenuItem value={"1"}>Fax</MenuItem>
                        <MenuItem value={"2"}>Thoại</MenuItem>
                        <MenuItem value={"3"}>Email</MenuItem>
                        <MenuItem value={"0"}>Khác</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel id="labelNoidung" className={this.state.validateStatus.NoiDung !== undefined
                          ? classes.labelError
                          : classes.label}>Nội dung:</InputLabel>
                      <TextareaAutosize
                        id="txtNoiDung"
                        labelId="labelNoidung"
                        aria-label="Nội dung(*):"
                        className={classes.noidung}
                        value={this.state.after.NoiDung}
                        InputProps={{
                          maxLength: 500,
                          className: classes.noidung,
                        }}
                        rowsMin={7}
                        onChange={(event) =>
                          this.saveField("NoiDung", event.target.value)
                        }
                        error={this.state.validateStatus.NoiDung !== undefined}
                        helperText={
                          this.state.validateStatus.NoiDung !== undefined
                            ? this.state.validateStatus.NoiDung.trangthai
                            : undefined
                        }
                      />
                  </Grid>
                  <Grid item xs={12}>
                    <InputLabel id="labelCoquan" className={
                      this.state.validateStatus.MaSK !== undefined
                          ? classes.labelError
                          : classes.label
                    }>Sự vụ(*):</InputLabel>
                    {this.state.loading_sukien ? (
                      <CircularProgress />
                    ) : (
                      <div style={{ zIndex: 99999 }}>
                        <SelectFilter
                          id="cboMaSK"
                          options={this.state.source_sukien}
                          placeholder=""
                          labelId="labelCoquan"
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          menuPosition={"fixed"}
                          value={this.state.after.MaSK}
                          onChange={(item) => this.saveField("MaSK", item)}
                        ></SelectFilter>
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="demo-simple-select-label">
                        Loại thông tin:
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className={classes.combo}
                        autoWidth={true}
                        labelWidth={100}
                        value={this.state.after.LoaiThongTin}
                        onChange={(event) =>
                          this.saveField("LoaiThongTin", event.target.value)
                        }
                      >
                        <MenuItem value={"1"}>Thông tin mới</MenuItem>
                        <MenuItem value={"2"}>Thông tin cập nhật</MenuItem>
                        <MenuItem value={"0"}>Khác</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12}>
                    {this.state.fileDinhKem.map((item, index) => (
                      <FileAttachControl
                        file={item}
                        requestDelete={(fileID) => {
                          //yeu cau xoa
                          this.setState({
                            showConfirmXoa: true,
                            requestXoaFileID: fileID,
                          });
                        }}
                      />
                    ))}
                    {this.state.showConfirmXoa ? (
                      <ConfirmDialog
                        message="Xóa file?"
                        callback={(ok) => {
                          //thuc hien xoa file
                          if (ok) {
                            this.setState({
                              showConfirmXoa: false,
                              validateStatus: {},
                              saving: true,
                              errorLog: "",
                            });
                            //call api to clear
                            server
                              .post("trucban/removeDinhkem", {
                                FileID: this.state.requestXoaFileID,
                              })
                              .then((response) => {
                                var before = {};
                                var after = { ...this.state.after };
                                Object.assign(before, after);
                                this.setState({
                                  before: before,
                                  after: after,
                                  dataChanged: false,
                                  canSaved: false,
                                  saving: false,
                                  errorLog: "",
                                  dataSaved: true,
                                  fileDinhKem: response,
                                });
                              })
                              .catch((error) =>
                                this.setState({
                                  saving: false,
                                  errorLog: error + "",
                                })
                              );
                          } else {
                            this.setState({
                              showConfirmXoa: false,
                            });
                          }
                        }}
                      />
                    ) : null}
                  </Grid>
                  <Grid item xs={12}>
                    {this.state.mountUploader &&
                    this.props.EditMode !== "xoa" ? (
                      <>
                        <DropzoneArea
                          filesLimit={100}
                          maxFileSize={32 * 1024 * 1024}
                          showFileNames={true}
                          dropzoneText="Kéo và thả file hoặc bấm vào đây"
                          showAlerts={false}
                          clearOnUnmount={true}
                          style={{ height: 40 }}
                          onChange={(files) => {
                            console.log("Files:", files);
                            this.saveField("files", files);
                          }}
                        />
                        <MyButton
                          color="primary"
                          text="Đính kèm"
                          onClick={() => {
                            //save dinh kem
                            if (this.state.files.length == 0) {
                              return;
                            }
                            this.setState({ saving: true, errorLog: "" });
                            const formData = new FormData();
                            this.state.files.map((item, index) => {
                              if (item.name !== undefined) {
                                formData.append(
                                  "file" + index,
                                  item,
                                  item.name
                                );
                              }
                            });
                            formData.append(
                              "TrucBanID",
                              this.state.after.TrucBanID
                            );
                            server
                              .upload("trucban/SaveDinhKem", formData)
                              .then((response) => {
                                console.log(
                                  "save dinh kem response:",
                                  response
                                );
                                var before = {};
                                this.setState({
                                  saving: false,
                                  errorLog: "",
                                  mountUploader: false,
                                  fileDinhKem: response,
                                });
                              })
                              .catch((error) =>
                                this.setState({
                                  saving: false,
                                  errorLog: error + "",
                                })
                              );
                          }}
                        />
                      </>
                    ) : this.state.after.TrucBanID !== 0 &&
                      this.props.EditMode !== "xoa" ? (
                      <MyButton
                        color="primary"
                        text="Thêm file"
                        onClick={() => this.setState({ mountUploader: true })}
                      />
                    ) : null}
                  </Grid>
                  <Grid item xs={2}>
                    {this.state.canSaved && this.props.EditMode !== "xoa" ? (
                      <MyButton
                        onClick={this.handleSave}
                        color="primary"
                        text="Lưu"
                      />
                    ) : null}
                  </Grid>
                  <Grid item xs={10}>
                    {this.state.saving ? (
                      <CircularProgress />
                    ) : this.state.errorLog === "" ? null : (
                      this.state.errorLog
                    )}
                  </Grid>
                </Grid>
              </div>
            </form>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}
const styles = (theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  thoigian: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  inputLabel: {
    margin: 4,
  },
  textbox: {
    marginLeft: 1,
    marginRight: 1,
    width: "100%",
  },
  combo: {
    marginLeft: 1,
    marginRight: 1,
    width: 200,
  },
  noidung: {
    height: 100,
    width: 550,
  },
  uppercaseText: {
    textTransform: "uppercase",
  },
  normalPanel: {
    backgroundColor: "lightskyblue",
    margin: 4,
  },
  expandedPanel: {
    backgroundColor: "skyblue",
  },
  label: {
    margin: 6,
  },
  labelError: {
    margin: 6,
    color: "red",
  },
});
export default withStyles(styles, { withTheme: true })(TrucBanDenEditDialog);
